"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_PRODUCT_AGGREGATED_ATTRIBUTE_VALUE_TOTALS = void 0;
const gql_1 = require("../../../../__generated__/gql");
exports.GET_PRODUCT_AGGREGATED_ATTRIBUTE_VALUE_TOTALS = (0, gql_1.gql)(`
  query ProductAggregatedAttributeValueTotals(
    $ids: [ID!],
    $productTreeId: ID!,
    $attribute: String,
    $productTreeNodeIds: [ID!]
  ) {
    catalogs(ids: $ids) {
      edges {
        node {
          id
          statistics(productTreeNodeIds: $productTreeNodeIds, productTreeId: $productTreeId) {
            attributes(attribute: $attribute) {
              groupedTotals {
                applied
                dimensions {
                  attribute
                  value
                }
                total
                unknown
                notApplicable
              }
            }
          }
        }
      }
    }
  }
`);
